import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/forgotPassword';
import { forgotPassword } from './utils';

export default function* listenForgotPassword() {
  yield takeEvery(actionTypes.forgotPassword.toString(), forgotPassword);
}
